import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import Home from './views/Home.vue';
import firebase from 'firebase/app';
// import IdentifyChords from '@/views/IdentifyChords.vue'
// import IdentifyIntervals from '@/views/IdentifyIntervals.vue'
// import IdentifyIntervalSizes from '@/views/IdentifyIntervalSizes.vue'
// import IdentifyChordInversions from '@/views/IdentifyChordInversions.vue'
// import IdentifyScales from '@/views/IdentifyScales.vue'
// import LevelCreator from '@/components/levelcreator/LevelCreator.vue'
// import Game from '@/views/Game.vue'

const Game = () => import(/* webpackChunkName: "Game" */ "@/views/Game.vue");
const IdentifyChords = () => import(/* webpackChunkName: "IdentifyChords" */ "@/views/IdentifyChords.vue");
const IdentifyIntervals = () => import(/* webpackChunkName: "IdentifyIntervals" */ "@/views/IdentifyIntervals.vue");
const IdentifyIntervalSizes = () => import(/* webpackChunkName: "IdentifyIntervalSizes" */ "@/views/IdentifyIntervalSizes.vue");
const IdentifyChordInversions = () => import(/* webpackChunkName: "IdentifyChordInversions" */ "@/views/IdentifyChordInversions.vue");
const IdentifyScales = () => import(/* webpackChunkName: "IdentifyScales" */ "@/views/IdentifyScales.vue");
const LevelCreator = () => import(/* webpackChunkName: "LevelCreator" */ "@/components/levelcreator/LevelCreator.vue");
const UserAccount = () => import(/* webpackChunkName: "UserAccpunt" */ "@/views/UserAccount.vue");
const GlobalSettings = () => import(/* webpackChunkName: "UserAccpunt" */ "@/views/GlobalSettings.vue");

Vue.use(Router)

const router = new Router({
  mode: '',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login/',
      name: 'login',
      component: Home
    },
    {
      path: '/signup/',
      name: 'signup',
      component: Home
    },
    {
      path: '/account/', 
      name: 'account',
      component: UserAccount,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings/', 
      name: 'settings',
      component: GlobalSettings,
      meta: { requiresAuth: true }
    },
    {
      path: '/identify-chords',
      name: 'IdentifyChords',
      component: IdentifyChords
    },
    {
      path: '/identify-chords/create-exercise',
      name: 'createIdentifyChordsExercise',
      component: LevelCreator,
      meta: { requiresAuth: true }
    },
    {
      path: '/identify-chords/edit-exercise/:id',
      name: 'editIdentifyChordsExercise',
      component: LevelCreator
    },
    {
      path: '/identify-chords/exercise/:id',
      name: 'playIdentifyChordsExercise',
      component: Game
    },
    {
      path: '/identify-chords/exercise/user/:id',
      name: 'playIdentifyChordsUserExercise',
      component: Game
    },
    {
      path: '/identify-intervals',
      name: 'IdentifyIntervals',
      component: IdentifyIntervals
    },
    {
      path: '/identify-intervals/create-exercise',
      name: 'createIdentifyIntervalsExercise',
      component: LevelCreator,
      meta: { requiresAuth: true }
    },
    {
      path: '/identify-intervals/edit-exercise/:id',
      name: 'editIdentifyIntervalsExercise',
      component: LevelCreator
    },
    {
      path: '/identify-intervals/exercise/:id',
      name: 'playIdentifyIntervalsExercise',
      component: Game
    },
    {
      path: '/identify-intervals/exercise/user/:id',
      name: 'playIdentifyIntervalsUserExercise',
      component: Game
    },
    {
      path: '/compare-interval-sizes',
      name: 'CompareIntervalSizes',
      component: IdentifyIntervalSizes
    },
    {
      path: '/compare-interval-sizes/create-exercise',
      name: 'createCompareIntervalSizesExercise',
      component: LevelCreator,
      meta: { requiresAuth: true }
    },
    {
      path: '/compare-interval-sizes/edit-exercise/:id',
      name: 'editCompareIntervalSizesExercise',
      component: LevelCreator
    },
    {
      path: '/compare-interval-sizes/exercise/:id',
      name: 'playCompareIntervalSizesExercise',
      component: Game
    },
    {
      path: '/compare-interval-sizes/exercise/user/:id',
      name: 'playCompareIntervalSizesUserExercise',
      component: Game
    },
    {
      path: '/identify-chord-inversions',
      name: 'IdentifyChordInversions',
      component: IdentifyChordInversions
    },
    {
      path: '/identify-chord-inversions/create-exercise',
      name: 'createIdentifyChordInversionsExercise',
      component: LevelCreator,
      meta: { requiresAuth: true }
    },
    {
      path: '/identify-chord-inversions/edit-exercise/:id',
      name: 'editIdentifyChordInversionsExercise',
      component: LevelCreator
    },
    {
      path: '/identify-chord-inversions/exercise/:id',
      name: 'playIdentifyChordInversionsExercise',
      component: Game
    },
    {
      path: '/identify-chord-inversions/exercise/user/:id',
      name: 'playIdentifyChordInversionsUserExercise',
      component: Game
    },
    {
      path: '/identify-scales',
      name: 'IdentifyScales',
      component: IdentifyScales
    },
    {
      path: '/identify-scales/create-exercise',
      name: 'createIdentifyScalesExercise',
      component: LevelCreator,
      meta: { requiresAuth: true }
    },
    {
      path: '/identify-scales/edit-exercise/:id',
      name: 'editIdentifyScalesExercise',
      component: LevelCreator
    },
    {
      path: '/identify-scales/exercise/:id',
      name: 'playIdentifyScalesExercise',
      component: Game
    },
    {
      path: '/identify-scales/exercise/user/:id',
      name: 'playIdentifyScalesUserExercise',
      component: Game
    }

  ]
})
// Guards

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let user = firebase.auth().currentUser;
    if (!user) {
      // Need to login
      // store.dispatch("setShowLogInDialog", true);
      store.dispatch('setShowLoginToAccessDialog', true);
      // next({
      //   name: 'login'
      // });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;